// ** Third Party Components
import styled from "styled-components";

// ** Styles Import
import { breakpoints } from "styles/grid";

// #####################################################

export const StyledSimpleList = styled("ul")`
	margin: 0;

	li {
		display: flex;
		&:first-child {
			margin-top: 0rem;
		}

		&:not(:first-child) {
			margin-top: 0.5rem;
		}

		&:last-child {
			margin-bottom: 0rem;
		}

		@media (max-width: ${breakpoints.desktop - 1}px) {
			&:last-child {
				margin-bottom: 0rem;
			}
		}
	}
`;

StyledSimpleList.displayName = "BrowserSimpleList";

// #####################################################
